// extracted by mini-css-extract-plugin
module.exports = {"img":"_9400a595a7--img--Shiy6","letter-img":"_9400a595a7--letter-img--_ER5E","circle":"_9400a595a7--circle--u4Haq"};